import { type FC } from 'react'
import { SegmentedControl } from '../../components/SegmentedControl/SegmentedControl'
import { type TeamChipKey, visibleTeamChips } from './teamChips'

export interface TeamChipBarProps {
  activeChip: TeamChipKey
  counts: Partial<Record<TeamChipKey, number>>
  hasInviteScope: boolean
  onSelect: (chip: TeamChipKey) => void
}

export const TeamChipBar: FC<TeamChipBarProps> = ({ activeChip, counts, hasInviteScope, onSelect }) => (
  <SegmentedControl
    ariaLabel='Team list filters'
    activeKey={activeChip}
    options={visibleTeamChips(hasInviteScope).map((chip) => ({
      key: chip.key,
      label: chip.label,
      count: counts[chip.key],
      hideCount: chip.key === 'deactivated',
    }))}
    onSelect={(key) => onSelect(key as TeamChipKey)}
  />
)
